import React from "react";
import { useSpring, animated } from "react-spring";
import { useInView } from "react-intersection-observer";
import three from "../../asset/landing_images/landing-one.webp";
import two from "../../asset/landing_images/landing-two.webp";
import one from "../../asset/landing_images/landing-three.webp";

const LandingProfile = () => {
  const { ref: containerRef, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  // Animations for each image coming from different directions
  const imageAnimation1 = useSpring({
    transform: inView ? "translate(0px, 0px)" : "translate(-100px, -100px)",
    opacity: inView ? 1 : 0,
    config: { duration: 1000 },
  });

  const imageAnimation2 = useSpring({
    transform: inView ? "translate(10px, 10px)" : "translate(100px, -100px)",
    opacity: inView ? 1 : 0,
    config: { duration: 1200 },
  });

  const imageAnimation3 = useSpring({
    transform: inView ? "translate(20px, 20px)" : "translate(-100px, 100px)",
    opacity: inView ? 1 : 0,
    config: { duration: 1400 },
  });

  // Text animation from the right
  const textAnimation = useSpring({
    transform: inView ? "translateX(0)" : "translateX(50px)",
    opacity: inView ? 1 : 0,
    config: { duration: 1000 },
  });

  // Responsive styles
  const isMobileOrTablet = window.innerWidth <= 1024;

  return (
    <div
      ref={containerRef}
      style={{
        display: "flex",
        flexDirection: isMobileOrTablet ? "column" : "row",
        justifyContent: isMobileOrTablet ? "center" : "space-evenly",
        alignItems: "center",
        textAlign: isMobileOrTablet ? "center" : "left",
        marginTop:isMobileOrTablet ? "8rem" :"10rem",
        padding: isMobileOrTablet ? "0 1rem" : "0",
      }}
    >
      <div
        style={{
          position: "relative",
          width: isMobileOrTablet ? "70%" : "400px",
          height: isMobileOrTablet ? "250px" : "300px",
          marginBottom: isMobileOrTablet ? "4rem" : "0",
        }}
      >
        {/* Animated Images */}
        <animated.img
          src={one}
          alt="Background"
          style={{ ...imageAnimation1, ...imageStyle1 }}
        />
        <animated.img
          src={two}
          alt="Middle Layer"
          style={{ ...imageAnimation2, ...imageStyle2 }}
        />
        <animated.img
          src={three}
          alt="Foreground"
          style={{ ...imageAnimation3, ...imageStyle3 }}
        />
      </div>

      {/* Animated Text Section */}
      <animated.div style={textAnimation}>
        <h1
          style={{
            color: "#000",
            marginBottom:'2rem',
            textAlign: isMobileOrTablet ? "center" : "left",
          }}
        >
          Customized Profiles: <br />
          Your{" "}
          <span style={{ color: "#30CDD8", fontWeight: "bold" }}>
            Space,
          </span>{" "}
          Your <span style={{ color: "#30CDD8", fontWeight: "bold" }}>Way</span>
        </h1>
        <p
          style={{
            textAlign: isMobileOrTablet ? "center" : "left",
            marginTop: isMobileOrTablet ? "0" : "-1.3rem",
          }}
        >
          Design your profile with unique avatars and <br />
          cover photos. <br />
          Share updates, media, and milestones with <br />
          your network. <br />
          Control who sees your content with flexible <br />
          privacy settings.
        </p>
        <a href="https://www.youthplus.ng" style={{textDecoration:'none', }} target="blank">
        <button
          style={{
            color: "#4E99DD",
            border: "2px solid #4E99DD",
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: isMobileOrTablet ? "15px" : "20px",
            marginTop: isMobileOrTablet ? "1rem" : "0",
          }}
        >
          Learn more
        </button></a>
      </animated.div>
    </div>
  );
};

// Styles for images
const imageStyle1 = {
  position: "absolute",
  top: "0",
  left: "0",
  width: "100%",
  height: "100%",
  borderRadius: "10px",
  zIndex: "1",
};

const imageStyle2 = {
  position: "absolute",
  top: "10px",
  left: "10px",
  width: "100%",
  height: "100%",
  borderRadius: "10px",
  zIndex: "2",
};

const imageStyle3 = {
  position: "absolute",
  top: "20px",
  left: "20px",
  width: "100%",
  height: "100%",
  borderRadius: "10px",
  zIndex: "3",
};

export default LandingProfile;
